
export const sortItems = (data: any[], order: string) => {
    let resultados: any[] = JSON.parse(JSON.stringify(data));
    if (order === 'a-z') {
        resultados.sort((a, b) => a?.title?.localeCompare(b?.title) || a?.name?.localeCompare(b?.name));
    } else if (order === 'z-a') {
        resultados.sort((a, b) => b?.title?.localeCompare(a?.title) || b?.name?.localeCompare(a?.name));
    }
    return resultados;
}